/**
 * Created by pzf on 18/9/1.
 *
 */
import Popedit from './Popedit';
export default Popedit;
//# sourceMappingURL=index.js.map
